







































































































import Vue from "vue";
import moment from "moment";
import { mapState, mapGetters } from "vuex";
import { on } from "iview/src/utils/dom";
import ExtendTrial from "./extend-trial.vue";

export default Vue.extend({
  name: "FreeTrialList",
  components: { ExtendTrial },
  props: {
    member: Object,
  },
  data() {
    let context = this as any;
    return {
      showAddPriority: false,
      mediaMatched: null,
      statusFilter: "open",
      showExtendTrial: false,
      edittingAccount: null,
      accounts: [],
    };
  },
  computed: {
    ...mapState("billing", ["loading", "freeTrialAccounts"]),
    columns() {
      let context = this as any;
      let result: Array<any> = new Array();

      if (context.statusFilter === "open") {
        result.push({
          title: "DAYS",
          key: "openDays",
          slot: "openDays",
          minWidth: 80,
          sortable: true,
        });
      } else if (context.statusFilter === "expired") {
        result.push({
          title: "DAYS",
          key: "expiredDays",
          slot: "expiredDays",
          minWidth: 80,
          sortable: true,
        });
      } else if (context.statusFilter === "canceled") {
        result.push({
          title: "DAYS",
          key: "canceledDays",
          slot: "canceledDays",
          minWidth: 80,
          sortable: true,
        });
      } else if (context.statusFilter === "converted") {
        result.push({
          title: "DAYS",
          key: "convertedDays",
          slot: "convertedDays",
          minWidth: 80,
          sortable: true,
        });
      }

      result = result.concat([
        {
          title: "ACCOUNT NAME",
          key: "name",
          slot: "name",
          minWidth: 180,
          sortable: true,
        },
        {
          title: "OWNER",
          key: "originalOwnerName",
          slot: "originalOwnerName",
          minWidth: 120,
          align: "center",
          sortable: true,
        },
        {
          title: "EMAIL",
          key: "originalOwnerEmailAddress",
          slot: "originalOwnerEmailAddress",
          minWidth: 120,
          align: "center",
          sortable: true,
        },
        {
          title: "PHONE",
          key: "originalOwnerPhoneNumber",
          slot: "originalOwnerPhoneNumber",
          minWidth: 120,
          align: "center",
          sortable: true,
        },
      ]);

      if (context.statusFilter === "converted") {
        result.push({
          title: "GOATSUCCESS ID",
          key: "id",
          slot: "id",
          minWidth: 80,
          sortable: true,
        });

        result.push({
          title: "STRIPE ID",
          key: "customerId",
          slot: "customerId",
          minWidth: 80,
          sortable: true,
        });
      } else {
        result.push({
          title: "TEAMS",
          key: "teamCount",
          slot: "teamCount",
          minWidth: 70,
          sortable: true,
        });

        result.push({
          title: "GOALS",
          key: "goalCount",
          slot: "goalCount",
          minWidth: 70,
          sortable: true,
        });

        result.push({
          title: "PROJECTS",
          key: "projectCount",
          slot: "projectCount",
          minWidth: 80,
          sortable: true,
        });

        result.push({
          title: "PLAYBOOKS",
          key: "playbookCount",
          slot: "playbookCount",
          minWidth: 100,
          sortable: true,
        });
      }

      if (context.statusFilter === "open") {
        result.push({
          title: "EXPIRATION DATE",
          key: "endDate",
          slot: "endDate",
          minWidth: 120,
          sortable: true,
        });
      } else if (context.statusFilter === "expired") {
        result.push({
          title: "CANCEL DATE",
          key: "cancelDate",
          slot: "cancelDate",
          minWidth: 120,
          sortable: true,
        });
      } else if (context.statusFilter === "canceled") {
        result.push({
          title: "CANCELED DATE",
          key: "canceledDate",
          slot: "canceledDate",
          minWidth: 120,
          sortable: true,
        });
      } else if (context.statusFilter === "converted") {
        result.push({
          title: "CONVERTED DATE",
          key: "convertedDate",
          slot: "convertedDate",
          minWidth: 120,
          sortable: true,
        });
      }

      if (context.statusFilter !== "converted") {
        result.push({
          title: "EDIT",
          key: "edit",
          slot: "edit",
          minWidth: 40,
          sortable: true,
        });
      }

      if (this.mediaMatched === false) {
      }

      return result;
    },
    freeTrialData() {
      let context = this as any;

      return context.accounts.filter(
        (account) =>
          (context.statusFilter === "open" ? account.open : true) &&
          (context.statusFilter === "expired" ? account.expired : true) &&
          (context.statusFilter === "canceled" ? account.canceled : true) &&
          (context.statusFilter === "converted" ? account.converted : true)
      );
    },
  },
  watch: {
    freeTrialAccounts(newValue) {
      if (newValue) {
        let today = moment();

        this.accounts = newValue
          .filter((account) => account.freeTrial)
          .map((account) => {
            return {
              id: account.id,
              name: account.name,
              originalOwnerName: account.originalOwnerName,
              originalOwnerEmailAddress: account.originalOwnerEmailAddress,
              originalOwnerPhoneNumber: account.originalOwnerPhoneNumber,
              userCount: account.userCount,
              teamCount: account.teamCount,
              goalCount: account.goalCount,
              projectCount: account.projectCount,
              playbookCount: account.playbookCount,
              customerId: account.customerId,
              open: new Date() < new Date(account.freeTrial.endDate),
              openDays: !!account.freeTrial.endDate ? moment(account.freeTrial.endDate).diff(today, "days") : 0,
              expired: new Date(account.freeTrial.endDate) < new Date() && new Date(account.freeTrial.canceledDate) > new Date() && !account.freeTrial.convertedDate,
              expiredDays: !!account.freeTrial.canceledDate ? moment(account.freeTrial.canceledDate).diff(today, "days") : 0,
              canceled: new Date() > new Date(account.freeTrial.canceledDate) && !account.freeTrial.convertedDate,
              canceledDays: !!account.freeTrial.canceledDate ? today.diff(moment(account.freeTrial.canceledDate), "days") : 0,
              converted: !!account.freeTrial.convertedDate,
              convertedDays: !!account.freeTrial.convertedDate ? today.diff(moment(account.freeTrial.convertedDate), "days") : 0,
              endDate: account.freeTrial.endDate,
              canceledDate: account.freeTrial.canceledDate,
              convertedDate: account.freeTrial.convertedDate,
            };
          });
      }
    },
  },
  mounted() {
    on(window, "resize", this.onWindowResize);
    this.matchMedia();
  },
  methods: {
    matchMedia() {
      let matchMedia;
      if (window.matchMedia) {
        matchMedia = window.matchMedia;
      }

      this.mediaMatched = matchMedia("(max-width: 992px)").matches;
    },
    getRoleFilterOptions() {
      let groups = (this as any).joinedGroups ? (this as any).joinedGroups : [];

      return [...new Set(groups.map((g) => g.roleName))]
        .sort((a, b) => {
          return a == b ? 0 : a > b ? 1 : -1;
        })
        .map((roleName) => {
          return {
            label: roleName,
            value: roleName,
          };
        });
    },
    onWindowResize() {
      this.matchMedia();
    },
    getDateText(date) {
      return date ? moment(date).format("MMM D, YYYY") : "";
    },
    handleMenuItemClick(name, account) {
      switch (name) {
        case "extend":
          this.handleShowExtendTrial(account);
          break;
      }
    },
    handleShowExtendTrial(account) {
      this.edittingAccount = account;
      this.showExtendTrial = true;
    },
  },
});
